import { render, staticRenderFns } from "./FeeStructure.vue?vue&type=template&id=74c84177&"
import script from "./FeeStructure.vue?vue&type=script&lang=js&"
export * from "./FeeStructure.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports